import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["flush", "use", "height", "children"];
import { forwardRef } from 'react';
import styled from 'foundations-theming/utils';
import { useHeight, useMargin } from './Section.hooks';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { useWizardHeaderContext } from '../Wizard/WizardHeaderProvider';
import { useTabsContext } from '../Tabs/TabsProvider';
import { mergeOverrides } from '../../../utils/mergeOverrides';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledSection = styled.div.withConfig({
  displayName: "Section__StyledSection",
  componentId: "sc-1twakrk-0"
})(({
  $height,
  $margin,
  $cssStyles,
  $styleOverrides
}) => {
  return Object.assign({
    height: $height
  }, $margin, $cssStyles, $styleOverrides);
});
const SectionWithRef = (_ref, ref) => {
  var _wizardHeaderContext$, _tabsContext$tabsSect;
  let {
      flush = false,
      use = 'default',
      height: heightProp,
      children
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(restProps);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const margin = useMargin(use, flush);
  const height = useHeight(heightProp);
  const hasPaddingBlockStart = 'paddingBlockStart' in restProps || 'paddingBlock' in restProps || 'padding' in restProps;
  const wizardHeaderContext = useWizardHeaderContext();
  const tabsContext = useTabsContext();
  const sectionStyleOverrides = mergeOverrides((_wizardHeaderContext$ = wizardHeaderContext === null || wizardHeaderContext === void 0 ? void 0 : wizardHeaderContext.sectionStyleOverrides) !== null && _wizardHeaderContext$ !== void 0 ? _wizardHeaderContext$ : {}, (_tabsContext$tabsSect = tabsContext === null || tabsContext === void 0 ? void 0 : tabsContext.tabsSectionStyleOverrides) !== null && _tabsContext$tabsSect !== void 0 ? _tabsContext$tabsSect : {});
  return /*#__PURE__*/_jsx(StyledSection, Object.assign({
    ref: ref,
    $margin: margin,
    $height: height,
    $cssStyles: cssStyles,
    $styleOverrides: sectionStyleOverrides !== null && sectionStyleOverrides !== void 0 ? sectionStyleOverrides : {},
    "data-has-padding-block-start": hasPaddingBlockStart ? '' : undefined
  }, domProps, {
    children: children
  }));
};
export const Section = /*#__PURE__*/forwardRef(SectionWithRef);